
import ctrlMixins from './_mixins.js';
// @ts-ignore
import { customTemplate, ctrlParamsForAll } from './_common-stuff.ts';
import { getEmptyValueDisplay } from './../utils.js';
import dateUtil from '../util-date.js';
import { JSONPath } from 'jsonpath-plus';
// TODO кастомные темплейты
// https://stackoverflow.com/questions/50271809/vuejs-render-dynamic-template-for-component

// PIRS2018-7356
// дефолтное значение номера слова, после которого во всплывающую подсказку добавляется разрыв строки
// переопределяется атрибутом data-title-split для элемента с наличием атрибута title в кастомном шаблоне
var DEFAULT_TITLE_SPLIT = 7;

export default {
	name: 'ctrl_static',
	meta: {
		// это наши данные, т.е. вуй при объявлении компонента их не использует
		title: 'Статический текст',
		params: {
			isLink: {
				name: 'Ссылка на карточку',
				tip: 'Если проставить этот чекбокс, текст будет ссылкой ведущей в карточку',
				editType: 'checkbox',
			},
			doEscape: {
				name: 'Экранирование HTML',
				tip: 'Если проставить этот чекбокс, теги будут выведены как текст',
				editType: 'checkbox',
			},
			dateTimeFormat: {
				name: 'Дата/время',
				editType: 'datetimeFormatRadio',
			},
			customTemplate,
			isPreformatted: {
				name: 'Сохранять форматирование',
				tip: 'Если проставить этот флаг, сохраняются переносы строк и проч.',
				editType: 'checkbox',
			},
			isConst: {
				name: 'Константа родительского АРМ',
				tip: 'Значение будет восприниматься UARM как константа для родительского АРМ',
				editType: 'checkbox',
			},
			truncated: {
				name: 'Обрезка текста',
				tip: 'Будет показано не более указанного числа строк, с многоточием в конце. 0 - показать весь текст',
				editType: 'number',
			},
			nameInPopupChild: {
				name: 'Название поля в модальном дочернем АРМе',
				tip: 'Если это значение название заполнено, то значение поля попадёт в модальный дочерний АРМ',
				editType: 'input',
			},
			backgroundList: {
				name: 'Фон текста',
				tip: 'Если проставить этот чекбокс, то можно добавить условие при котором цвет фона текста будет применяться.',
				editType: 'background',
			},
			emptyValueDisplayProps: {
				name: 'Кастомный показ пустых значений',
				tip: 'Если проставить флаг "вкл", то поле с пустым значением будет либо скрыто целиком, либо, если указан текст-плейсхолдер, вместо пустой строки будет выведен этот текст',
				editType: 'emptyValueDisplayPropsEd',
			},
			expiredBulb: {
				name: 'Индикатор актуальности',
				tip: 'Если проставить этот чекбокс, то можно добавить условие при котором появится индикатор актуальности контента.',
				editType: 'expiredBulb',
			},
			...ctrlParamsForAll,
		},
	},
	mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	props: {
		// большая часть пропсов приезжает из ctrlMixins!
		value: {
			default: '',
		},
		rowAccess: {
			default: () => ({
				groups: [],
			}),
		},
		record_data: {},
	},
	data() {
		var staticValue;
		var ctrlParams = this.$props.field_meta.ctrlParams;

		// PIRS-2-10996 - есть ли значение в списке групп доступа
		const targetAccessValue =
			this.$props.rowAccess.groups.find((group) => {
				return group.id === this.$props.value;
			}) || {};

		if (this.$props.field_meta.dbcoltype === 'boolean') {
			if (this.$props.value === true) {
				staticValue = 'Да';
			} else if (this.$props.value === false) {
				staticValue = 'Нет';
			} else {
				staticValue = 'Не задано';
			}
		} else if (ctrlParams.dateTimeFormat === 1) {
			// Дата
			staticValue = this.$props.value ? dateUtil.isoToHumanDate(this.$props.value) : '';
		} else if (ctrlParams.dateTimeFormat === 2) {
			// Дата+время
			staticValue = this.$props.value ? dateUtil.isoToHuman(this.$props.value) : '';
		} else if (ctrlParams.dateTimeFormat === 3) {
			// Время
			staticValue = this.$props.value ? dateUtil.isoToHumanTime(this.$props.value) : '';
		} else if (ctrlParams.dateTimeFormat === 4) {
			// Дата+время+сек
			staticValue = this.$props.value ? dateUtil.isoToHumanSec(this.$props.value) : '';
		} else if (ctrlParams.dateTimeFormat === 5) {
			// ММ.ГГГГ
			staticValue = this.$props.value ? dateUtil.dateObjToHumanMonth(this.$props.value) : '';
		} else if (targetAccessValue.name) {
			// PIRS-2-10996 - если значение соответствует группе доступа, выводим сюда название группы доступа
			staticValue = targetAccessValue.name;
		} else {
			staticValue = this.$props.value;
		}
		return {
			truncated: ctrlParams.truncated || 0,
			staticValue,
			isLink: !!ctrlParams.isLink,
			doEscape: !!ctrlParams.doEscape,
			wrapperClass: ctrlParams.isPreformatted ? ' ctrl-static-preformatted' : '',
			backgroundColor: null,
			expiredBulbColor: null,
			emptyValueDisplay: getEmptyValueDisplay(
				this.$props.is_new_record,
				this.$props.field_meta.ctrlParams,
				this.$props.value,
			),
		};
	},
	mounted() {
		this.splitTitle(); // PIRS2018-7356

		if (
			this.c_ctrlParams.hasOwnProperty('backgroundList') &&
			this.c_ctrlParams['backgroundList'] &&
			Array.isArray(this.c_ctrlParams['backgroundList']) &&
			this.c_ctrlParams['backgroundList'].length
		) {
			const backgroundList = this.c_ctrlParams['backgroundList'];
			const json = { list: { items: [this.record_data] } };

			const background = backgroundList.find((b) => {
				const { rule, color } = b;

				if (rule && color) {
					const path = `$..items[?(${rule})]`;
					const result = JSONPath({ path, json });

					return result.length > 0;
				}
				return false;
			});

			if (background) {
				const { color } = background;
				this.backgroundColor = color;
			}
		}
		if (
			this.c_ctrlParams.hasOwnProperty('expiredBulb') &&
			this.c_ctrlParams['expiredBulb'] &&
			Array.isArray(this.c_ctrlParams['expiredBulb']) &&
			this.c_ctrlParams['expiredBulb'].length
		) {
			const expiredBulb = this.c_ctrlParams['expiredBulb'];
			function dateDiff(a, b) {
				const _MS_PER_DAY = 1000 * 60 * 60 * 24;
				const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
				const utc2 = Date.UTC(dateUtil.isoGet(b, 'year'), dateUtil.isoGet(b, 'month'), dateUtil.isoGet(b, 'date'));
				return Math.floor((utc2 - utc1) / _MS_PER_DAY);
			}
			const currDate = dateUtil.getCurrentDate();
			const dateVal = new Date(this.$props.value);
			const result = dateDiff(currDate, dateVal);

			expiredBulb.forEach((el) => {
				const { rule, color } = el;
				let limits = rule.trim().split(',');

				if (limits[0] && limits[1]) {
					if (result >= limits[0] && result <= limits[1]) {
						this.expiredBulbColor = color;
					}
				} else if (!limits[1]) {
					if (result >= limits[0]) {
						this.expiredBulbColor = color;
					}
				} else if (!limits[0]) {
					if (result <= limits[1]) {
						this.expiredBulbColor = color;
					}
				}
			});
		}
	},
	methods: {
		splitTitle() {
			var blocksWithTitle = this.$el.querySelectorAll('[title]');
			for (var i = 0; i < blocksWithTitle.length; i++) {
				var block = blocksWithTitle[i];
				var splitIndex = block.dataset.titleSplit || DEFAULT_TITLE_SPLIT;

				block.title = block.title
					.split(' ')
					.map(function (word, i) {
						if ((i + 1) % splitIndex === 0) {
							return word + '\u000A';
						}
						return word;
					})
					.join(' ');
			}
		},
	},
};
